var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 149 149",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-1019.63,-1352.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.767,354.041L255.37,354.401C257.584,355.72 260.104,356.418 262.654,356.418C270.523,356.418 276.925,350.017 276.925,342.148C276.925,334.28 270.523,327.878 262.654,327.878C254.787,327.878 248.385,334.28 248.385,342.148C248.385,344.746 249.106,347.304 250.472,349.546L250.842,350.155L249.416,355.475L254.767,354.041ZM244.712,360.178L247.266,350.649C245.82,348.039 245.059,345.116 245.059,342.148C245.059,332.446 252.953,324.552 262.654,324.552C272.357,324.552 280.251,332.446 280.251,342.148C280.251,351.851 272.357,359.745 262.654,359.745C259.742,359.745 256.864,359.009 254.291,357.613L244.712,360.178Z",
    style: {
      fill: "rgb(0,171,93)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-1019.63,-1352.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.2,344.595C268.476,344.162 267.534,343.678 266.681,344.028C266.026,344.295 265.608,345.32 265.184,345.843C264.966,346.112 264.707,346.154 264.372,346.019C261.915,345.04 260.032,343.4 258.676,341.14C258.446,340.788 258.488,340.512 258.765,340.186C259.174,339.704 259.689,339.157 259.799,338.506C259.91,337.857 259.605,337.096 259.336,336.518C258.993,335.778 258.609,334.724 257.868,334.305C257.187,333.92 256.29,334.136 255.684,334.63C254.637,335.483 254.132,336.819 254.147,338.143C254.151,338.52 254.198,338.895 254.285,339.258C254.497,340.132 254.9,340.948 255.355,341.723C255.697,342.308 256.07,342.875 256.471,343.42C257.786,345.206 259.42,346.757 261.314,347.917C262.26,348.496 263.279,349.004 264.334,349.353C265.517,349.745 266.571,350.151 267.849,349.909C269.187,349.655 270.506,348.827 271.037,347.537C271.194,347.156 271.272,346.731 271.185,346.328C271.003,345.494 269.875,344.998 269.2,344.595Z",
    style: {
      fill: "rgb(0,171,93)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c48bd93aecb6425a1c5f265dc4237de1.svg";
export { ForwardRef as ReactComponent };